import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";

Vue.use(CKEditor);
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

// RENDER THE VIEWS
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
